"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
var _userActionTypes = require("./userActionTypes");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  busy: false,
  userContext: {},
  partnerContext: [],
  hasIdentified: false,
  hasGuestIdentified: false
};
var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _userActionTypes.REQUEST_PARTNER_STATUS:
    case _userActionTypes.REQUEST_USER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          busy: true
        });
      }
    case _userActionTypes.RECEIVE_USER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          busy: false,
          userContext: action.payload
        });
      }
    case _userActionTypes.IDENTIFY_USER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasIdentified: true
        });
      }
    case _userActionTypes.IDENTIFY_GUEST_USER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasGuestIdentified: true
        });
      }
    case _userActionTypes.RECEIVE_USER_STATUS:
      {
        var updatedUserContext = Object.assign({}, state.userContext, {
          status: action.payload.status
        });
        return Object.assign({}, state, {
          busy: false,
          userContext: updatedUserContext
        });
      }
    case _userActionTypes.RECEIVE_PARTNER_STATUS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          busy: false,
          partnerContext: action.payload
        });
      }
    default:
      return state;
  }
};
var _default = exports.default = userReducer;